import { HStack, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import GarrettsCards from "./GarrettsCards";

export default function GarrettsSide({ gameState, stepPhase }) {
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");

  // get info from gameState
  const { garrettDeck, garrettDownCards, garrettEarnedCards } = gameState;

  return (
    // Garrett's cards display
    <VStack minW="175px" maxW="175px" h="325px" justify="space-between">
      {/* Garrett Active Deck */}
      <HStack w="100%" justify="end" align="start" spacing="10px">
        <Text
          fontSize="lg"
          color={textColor}
          fontFamily="Lilita One, sans-serif"
          lineHeight="18px"
        >
          Garrett
        </Text>
        <VStack spacing="0px" minW="60px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {garrettDeck.length +
              garrettDownCards.length +
              garrettEarnedCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Total
          </Text>
        </VStack>
      </HStack>
      <GarrettsCards gameState={gameState} stepPhase={stepPhase} />
      {/* Garrett Earned Deck */}
      <HStack w="100%" justify="end" align="center" spacing="0px">
        <VStack spacing="0px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {garrettDeck.length + garrettDownCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Deck
          </Text>
        </VStack>
        <VStack spacing="0px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {garrettEarnedCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Earned
          </Text>
        </VStack>
      </HStack>
    </VStack>
  );
}
